export default __webpack_public_path__ + "static/media/VISAiX.fe859acb073bf25547c7b0ca503499c2.webp";